 
export const DataType = Object.freeze({
    Numeric: 0,
    Date: 1,
    Double: 2,
    Time: 3,
});
